<template>
    <div class="plan-services flow__panel flow__container-fixed">
        <div>
            <section class="plan-services__top">
                <h2>{{ myResources.title }}</h2>
                <p>{{ myResources.introText }}</p>
            </section>
            <hh-form class="plan-services__form">
                <hh-form-group v-for="service in services"
                               :key="service.key">
                    <hh-label :for-def="service.key"
                              :tabstop="true">
                        <hh-checkbox :def="service.key"
                                     :tabstop="false"
                                     :disabled="selectionIsDisabled(service.key)"
                                     :value="getServiceOfferingValue(service.key)"
                                     @input="setServiceOfferingValueAsync(service.key, $event)" />
                        {{ service.label }}
                    </hh-label>
                </hh-form-group>
            </hh-form>
            <div>
                <cta-tile class="plan-services__cta cta-tile--grid"
                          name="services"
                          :button-text="commonResources.continue"
                          show-small-image
                          :secondary-button-text="myResources.btnBack"
                          icon-class="fas fa-chevron-circle-right"
                          icon-location="post"
                          type="cta"
                          breakout-extended
                          @click="onProceed"
                          @secondary-click="onBack" />
            </div>
        </div>
    </div>
</template>

<script>

import Vuex from 'vuex'

import PlanBuilderManager from '@/plan-builder-manager'
import ProgressManager from '@/progress-manager'
import Project from '@/models/project'
import ServiceBasketManager from '@/service-basket-manager'

import CtaTile from '@/components/app-core/cta-tile'
import ResourcesHelper from '@/components/resources-helper'

export default {
    mixins: [
        ResourcesHelper,
    ],

    computed: {
        ...Vuex.mapState({
            /**
             * @param {VuexState} stateStore
             * @returns {Project}
             */
            currentProject: stateStore => Project.ensure(stateStore.improvements.currentProject),

            /**
             * @param {VuexState} stateStore
             * @returns {Array<ServiceBasketItem>}
             */
            serviceBasketItems: stateStore => stateStore.serviceBasket.basket.items,
        }),

        /**
         * Return the resources object for this page.
         * @return {PlanServicesResources}
         */
        myResources() {
            return this.parseResources('views.planServices')
        },

        /**
         * @returns {Array<ServiceOffering>}
         */
        services() {
            return this.$scheme.services
        },
    },

    async created() {
        if (this.services.length === 0) this.onProceed()

        await ServiceBasketManager.loadBasketAsync()
    },

    methods: {
        /**
         * Returns true if the service can be selected.
         * @param {string} key
         * @returns {boolean}
         */
        selectionIsDisabled(key) {
            const isSelected = this.getServiceOfferingValue(key)

            if (!isSelected) return false

            const service = this.services.find(s => s.key === key)

            return service && service.ownsAnyBasketItems(this.serviceBasketItems)
        },

        /**
         * Get the service offering value of the current project for the given key. Convert
         * it to a boolean value of true if Y, otherwise false, and return it.
         * @param {string} key
         * @returns {boolean}
         */
        getServiceOfferingValue(key) {
            this.$logger.trackMethod('getServiceOfferingValue', 'plan-services.vue', { key })

            const services = this.currentProject && this.currentProject.services ? this.currentProject.services : []
            const service = services.find(n => n.key === key)

            return service === undefined ? false : service.value === 'Y'
        },

        /**
         * Take a boolean value from a checkbox and convert it to a string, Y if true, otherwise N.
         * Update the key and value on the service offering of the current project.
         * @params {string} key
         * @params {boolean} value
         */
        async setServiceOfferingValueAsync(key, value) {
            this.$logger.trackMethod('setServiceOfferingValueAsync', 'plan-services.vue', { key, value })

            await PlanBuilderManager.setServiceOfferingAsync(key, value ? 'Y' : 'N')
        },

        /**
         * Redirects the user flow differently, depending on whether this is a "Lite" or "Pro" plan builder.
         */
        onProceed() {
            this.$router.push(ProgressManager.getNext(this.$route.name))
        },

        /**
         * Event
         */
        onBack() {
            this.$router.push(ProgressManager.getPrevious(this.$route.name))
        },
    },

    components: {
        CtaTile,
    },
}

</script>

<style lang="scss">

.plan-services {
    @include element('form') {
        max-width: 50rem;
    }
}

</style>
